exports.f = Object.getOwnPropertySymbols;


// WEBPACK FOOTER //
// ./~/core-js/modules/_object-gops.js